module.exports = __webpack_public_path__ + "img/big-ship-wreck-1.1f3ddb6c.png";